<template>
  <div>
  <v-footer height="auto" class="grey darken-4 pa-3">
    <v-layout row wrap justify-center>
      <v-flex xs12 py-3 text-xs-center white--text>
        <CopyrightComponent/>
      </v-flex>
    </v-layout>
  </v-footer>
  </div>
</template>

<script>
import CopyrightComponent from './CopyrightComponent.vue'
export default {
  components: {
    CopyrightComponent
  }
}
</script>

<style scoped>
footer {
  font-family: 'Lato', sans-serif;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  /*margin-bottom: -112px;*/
  padding: 10px 0;
}
.body-2 {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/DashBoardFooter.vue